import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=059b11bf"
import script from "./Footer.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Footer.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports